module.exports = __webpack_public_path__ + "5f6b6f1b02a58b9ce2315758501453f9.mp4";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/singing-spear.mp4
// module id = 645
// module chunks = 0